export const leadColumns = ({
  selectedIds,
  handleSelect,
  handleSelectAll,
  totalRows,
}) => [
  {
    id: "select",
    label: (
      <input
        type="checkbox"
        checked={
          totalRows > 0 &&
          selectedIds.length === totalRows
        }
        onChange={handleSelectAll}
      />
    ),
    render: (lead) => (
      <input
        type="checkbox"
        checked={selectedIds.includes(lead.id)}
        onChange={() => handleSelect(lead.id)}
        onClick={(e) => e.stopPropagation()}
      />
    ),
  },
 
  {
    id: "title",
    label: "Lead",
 
    render: (lead) => (
      <div className="lead-cell">
        <div className="lead-name">
          {lead.title || "-"}
        </div>
 
        <div className="lead-org">
          {lead.organization?.name || "No Organization"}
        </div>
      </div>
    ),
 
    exportValue: (lead) => lead.title || "",
  },
 
{
  id: "status",
  label: "Status",

  render: (lead) => {
    const statusClass = `status-badge ${lead.status
      ?.toLowerCase()
      .replace(/\s+/g, "-")}`;

    return (
      <span className={statusClass}>
        {lead.status}
      </span>
    );
  },

  exportValue: (lead) => lead.status || "",
},
 
  {
    id: "source",
    label: "Source",
 
    render: (lead) => lead.source || "-",
  },
 
  {
    id: "lead_type",
    label: "Lead Type",
 
    render: (lead) => lead.lead_type || "-",
  },
 
  {
    id: "value",
    label: "VALUES",
 
    render: (lead) => lead.value || "1,00,000",
  },
 
  {
    id: "assigned",
    label: "Assigned To",
 
    render: (lead) =>
      lead.assigned_user?.name ||
      lead.assigned_user?.email ||
      "-",
 
    exportValue: (lead) =>
      lead.assigned_user?.name ||
      lead.assigned_user?.email ||
      "",
  },
 
  {
    id: "next_followup_date",
    label: "Next Follow Up",

    render: (lead) => {
      const followUpDate =
        lead.next_followup_date || lead.next_follow_up;
      return followUpDate
        ? new Date(followUpDate).toLocaleDateString()
        : "-";
    },

    exportValue: (lead) => {
      const followUpDate =
        lead.next_followup_date || lead.next_follow_up;
      return followUpDate
        ? new Date(followUpDate).toLocaleDateString()
        : "";
    },
  },
];
 
